module.exports = __webpack_public_path__ + "img/voltaje_a_blue.36b0a1b6.svg";